import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = ({ houseId }) => ['parentServices', houseId];

const getParentServices = async ({ houseId }) => {
  return await request.get(
    '/Request/parent_services',
    { houseId },
    'При загрузке услуг произошла ошибка'
  );
};

const useParentServices = ({ houseId, options }) =>
  useQuery(key({ houseId }), () => getParentServices({ houseId }), options);

export default useParentServices;
